export const FETCH_PRACTICE_MACHINES = "FETCH_PRACTICE_MACHINES";
export const FETCH_PRACTICE_MACHINES_START = "FETCH_PRACTICE_MACHINES_START";
export const FETCH_PRACTICE_MACHINES_SUCCESS = "FETCH_PRACTICE_MACHINES_SUCCESS";
export const FETCH_PRACTICE_MACHINES_ERROR = "FETCH_PRACTICE_MACHINES_ERROR";

export const FETCH_PRACTICE_USERS = "FETCH_PRACTICE_USERS";
export const FETCH_PRACTICE_USERS_START = "FETCH_PRACTICE_USERS_START";
export const FETCH_PRACTICE_USERS_SUCCESS = "FETCH_PRACTICE_USERS_SUCCESS";
export const FETCH_PRACTICE_USERS_ERROR = "FETCH_PRACTICE_USERS_ERROR";

export const FETCH_ROSTER = "FETCH_ROSTER";
export const FETCH_ROSTER_START = "FETCH_ROSTER_START";
export const FETCH_ROSTER_SUCCESS = "FETCH_ROSTER_SUCCESS";
export const FETCH_ROSTER_ERROR = "FETCH_ROSTER_ERROR";

export const ADD_UPDATE_ROSTER_EVENT = "ADD_UPDATE_ROSTER_EVENT";
export const ADD_UPDATE_ROSTER_EVENT_START = "ADD_UPDATE_ROSTER_EVENT_START";
export const ADD_UPDATE_ROSTER_EVENT_SUCCESS = "ADD_UPDATE_ROSTER_EVENT_SUCCESS";
export const ADD_UPDATE_ROSTER_EVENT_ERROR = "ADD_UPDATE_ROSTER_EVENT_ERROR";

export const DELETE_ROSTER_EVENT = "DELETE_ROSTER_EVENT";
export const DELETE_ROSTER_EVENT_START = "DELETE_ROSTER_EVENT_START";
export const DELETE_ROSTER_EVENT_SUCCESS = "DELETE_ROSTER_EVENT_SUCCESS";
export const DELETE_ROSTER_EVENT_ERROR = "DELETE_ROSTER_EVENT_ERROR";

export const ADD_ROSTER_RECURRING_EVENTS = "ADD_ROSTER_RECURRING_EVENTS";
export const ADD_ROSTER_RECURRING_EVENTS_START = "ADD_ROSTER_RECURRING_EVENTS_START";
export const ADD_ROSTER_RECURRING_EVENTS_SUCCESS = "ADD_ROSTER_RECURRING_EVENTS_SUCCESS";
export const ADD_ROSTER_RECURRING_EVENTS_ERROR = "ADD_ROSTER_RECURRING_EVENTS_ERROR";

export const fetchPracticeMachines = (practiceId) => {
    return {
        type: FETCH_PRACTICE_MACHINES,
        practiceId
    };
};

export const fetchPracticeUsers = (practiceId) => {
    return {
        type: FETCH_PRACTICE_USERS,
        practiceId
    };
};

export const fetchRoster = (payload) => {
    return {
        type: FETCH_ROSTER,
        payload
    };
};

export const addUpdateRosterEvent = (event, eventChangeInfo) => {
    return {
        type: ADD_UPDATE_ROSTER_EVENT,
        payload: {
            event,
            eventChangeInfo
        }
    };
};

export const deleteRosterEvent = (timeslotId) => {
    return {
        type: DELETE_ROSTER_EVENT,
        timeslotId
    };
};

export const addRosterRecurringEvents = (recurringEvents) => {
    return {
        type: ADD_ROSTER_RECURRING_EVENTS,
        recurringEvents
    };
};